<template>
  <b-modal
    entrance-transition="animated fadeIn"
    leave-transition="animated bounceOut"
    ref="modal"
    :centered="true"
    no-close-on-backdrop
    no-close-on-esc
    ok-title="Conferma"
    ok-variant="success"
    cancel-title="Annulla"
    cancel-variant="outline-secondary"
    :title="title ? title : 'Comunicazioni per utente'"
    size="lg"
    :hideHeaderClose="true"
    header-class="my-header-class"
    footer-class="my-footer-class"
  >

    <div slot="modal-title">
      <img
        src="../assets/images/logo-solo-img.png"
        alt="AEqua Roma"
        style="height:2rem;"
      >
      {{title ? title : "INFORMATIVA PRIVACY"}}
    </div>

    <h2
      class="text-center mt-4 text-uppercase"
      style="color: #862633"
    >
      Regolamento 679/2016/UE
    </h2>
    <div class="text-center">
      Informativa Interessati – Portale Patrimonio
    </div>

    <hr>

    <div>
      <object
        :data="urlPrivacy()"
        type="application/pdf"
        width="100%"
        height="400px"
      >
        <embed
          :src="urlPrivacy()"
          type="application/pdf"
        >
        <p>This browser does not support PDFs. Please download the PDF to view it: <a href="https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.pdf">Download PDF</a>.</p>
      </object>
    </div>

    <template slot="modal-footer">

      <b-button
        variant="success"
        class="m-2"
        @click="doConfermaLettura"
      >
        <font-awesome-icon
          icon="check"
          class="text-white mr-2"
        />Conferma lettura
      </b-button>

      <b-button
        variant="primary"
        @click="close"
      >
        <font-awesome-icon
          icon="times"
          class="mr-2"
        />Annulla
      </b-button>
    </template>
    <!-- </div> -->
  </b-modal>

</template>

<script>
import moment from 'moment'

export default {
  name: 'privacyIntermediarioModal',
  props: {
    title: { type: String }
  },
  data () {
    return {
      confermaLettura: null
    }
  },

  computed: {
    moment () {
      return moment
    }
  },

  methods: {
    async open ({ confermaLettura }) {
      try {
        this.confermaLettura = confermaLettura
        this.$refs.modal.show()
      } catch (err) {
        this.$ui.showError(err)
      }
    },
    async close () {
      try {
        // Annulla informativa privacy, non procedo con la creazione.
        this.$refs.modal.hide()
        this.$emit('confermaLettura', { confermaLettura: false })
      } catch (err) {
        this.$ui.showError(err)
      }
    },
    doConfermaLettura () {
      this.$ui.notify({
        type: 'confirm',
        title: 'Richiesta di conferma',
        message: "Confermi la presa visione dell'informativa sulla privacy?",
        okHandler: this.doConferma
      })
    },
    async doConferma () {
      try {
        this.$ui.notify({
          type: 'success',
          title: 'Esito operazione',
          message: `Confermata lettura comunicazione!`
        })
        this.$refs.modal.hide()
        this.$emit('confermaLettura', { confermaLettura: true })
      } catch (err) {
        this.$ui.showError(err)
      }
      this.loading = false
    },
    formatDateTime (dateStr) {
      return dateStr ? moment(dateStr).format('DD/MM/YYYY HH:mm') : ''
    },
    urlPrivacy () {
      return `/api/abilitazioni/privacy`
    }

  }
}
</script>

<style lang="stylus" scoped>
.btn-left >>> button {
  text-align: left !important;
}

/deep/ .my-header-class {
  background: #862633;
  color: white;
}

/deep/ .my-footer-class {
  color: #862633;
}
</style>
